var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("h1", { staticStyle: { "font-size": "16px" } }, [
      _vm._v("\n        " + _vm._s(_setup.props.heading) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { "font-size": "11px" } }, [
      _c("p", [
        _vm._v("\n            " + _vm._s(_setup.reportDate) + "\n        "),
      ]),
      _vm._v(" "),
      _setup.props.startDate && _setup.props.endDate
        ? _c("p", [
            _vm._v(
              "\n            Period - " +
                _vm._s(_setup.formatDate(_setup.props.startDate)) +
                " to " +
                _vm._s(_setup.formatDate(_setup.props.endDate)) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.props.rows && _setup.props.rows.length
        ? _c("table", { staticClass: "table table-condensed" }, [
            _c("thead", [
              _c(
                "tr",
                _vm._l(_setup.props.rows[0], function (value, key) {
                  return _c("td", { key: "head-" + key }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(key) +
                        "\n                "
                    ),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_setup.props.rows, function (row, rowIndex) {
                return _c(
                  "tr",
                  { key: "row-" + rowIndex },
                  _vm._l(row, function (value, cellKey, cellIndex) {
                    return _c(
                      "td",
                      { key: "cell-" + rowIndex + "-" + cellIndex },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(value) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  0
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }